const locationIntroSlide = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {



    const secIntro = document.getElementById('jsSecIntro');
    const slideWrap = secIntro.querySelector('.js-slide-wrap');
    const jsSwiper = slideWrap.querySelector('.js-swiper');

    let sW = window.innerWidth;
    let setSpaceBetween
    let setSpeed
    if (sW > 750) {
      setSpaceBetween = 30
      setSpeed = 15000
    } else {
      setSpaceBetween = 15
      setSpeed = 10000
    }

    const swiper = new Swiper(jsSwiper, {
      loop: true, // ループ有効
      slidesPerView: 'auto', // 一度に表示する枚数
      spaceBetween: setSpaceBetween, // スライド間の余白（px）
      speed: 10000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
    });



  }
})();
export default locationIntroSlide;